module.exports = __webpack_public_path__ + "static/media/21-9.8a94fd04.mp3";